import { htmlToPlainText } from 'utils/textUtils';

export const generateSeoProps = ({
	title = 'Pharmuni',
	description = 'Welcome to the world of Pharma',
	canonical = '',
	noIndex = false,
	image = ''
}) => {
	// Several pages forward a description straight from the API, where it comes
	// back as HTML. Meta tags need plain text, and the markup would otherwise
	// show up verbatim in search results.
	const plainDescription = htmlToPlainText(description);

	return {
		title: title,
		description: plainDescription,
		canonical: 'https://pharmuni.com/' + canonical,
		// next-seo reads `noindex` (lowercase) from the top level of the props.
		// It was previously passed inside `openGraph`, which is not a field
		// next-seo recognises there — it was dropped silently, and every page
		// rendered `<meta name="robots" content="index,follow">` regardless of
		// what the caller asked for.
		noindex: noIndex,
		openGraph: {
			type: 'website',
			locale: 'en_US',
			url: 'https://pharmuni.com/' + canonical,
			site_name: 'Pharmuni',
			title: title,
			description: plainDescription,
			...(image
				? {
					images: [
						{
							url: image.startsWith('http') ? image : `https://pharmuni.com/${image.replace(/^\/+/, '')}`,
							alt: title
						}
					]
				}
				: {})
			// images: [
			// 	{
			// 		url: 'https://pharmuni.com/wp-content/uploads/2022/10/PHU_Logo-1-1.svg',
			// 		alt: 'Pharmuni'
			// 	}
			// ]
		},
		additionalMetaTags: [
			{
				name: 'viewport',
				content: 'width=device-width, initial-scale=1.0'
			},
			{
				property: 'og:type',
				content: 'website'
			}
		]
	};
};
